import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  Progress,
} from '@bpinternal/ui-kit-next'
import type { ReactNode } from 'react'
import { cn } from '~/utils'

type Props = {
  className?: string
  title?: ReactNode
  description?: ReactNode
  footer?: ReactNode
  footerClassName?: string
  value: number
  children?: ReactNode
}

export const ProgressBarCard = ({
  className,
  description,
  footer,
  value,
  title,
  children,
  footerClassName,
  ...props
}: Props) => {
  return (
    <Card {...props} className={cn(className, 'flex flex-col')}>
      <CardHeader className="flex gap-2">
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent className="mt-auto">
        {children}
        <Progress
          value={value}
          className={cn(
            value >= 80
              ? 'bg-red-500/20 [&>div]:bg-red-500'
              : value >= 60
                ? 'bg-yellow-500/20 [&>div]:bg-yellow-500'
                : 'bg-blue-500/20 [&>div]:bg-blue-500'
          )}
        />
      </CardContent>
      {footer && <CardFooter className={footerClassName}>{footer}</CardFooter>}
    </Card>
  )
}
